import { render, staticRenderFns } from "./regDialog.vue?vue&type=template&id=f063f482&scoped=true&"
import script from "./regDialog.vue?vue&type=script&lang=js&"
export * from "./regDialog.vue?vue&type=script&lang=js&"
import style0 from "./regDialog.vue?vue&type=style&index=0&id=f063f482&prod&scoped=true&lang=scss&"
import style1 from "./regDialog.vue?vue&type=style&index=1&id=f063f482&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f063f482",
  null
  
)

export default component.exports